var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"question-item"},[_c('div',{staticClass:"question-item-content"},[_c('div',{staticClass:"question-item-content-title"},[_vm._v(_vm._s(_vm.data.title))]),_vm._v(" "),_c('div',{staticClass:"question-item-content-answer"},[_vm._v(_vm._s(_vm.data.content))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }